import { PaymentInOutFlowType } from "@/enums/enums";

export function ToBankReferenceList(_bankReferenceList: any) {
  const bankReferenceList: any = [];
  _bankReferenceList.forEach((bankReferenceItem: any) => {
    const bankReference = {
      bankId: bankReferenceItem.bankId,
      logoFilePath: bankReferenceItem.logoFilePath,
      bankShortName: bankReferenceItem.bankShortName,
      bankFullName: bankReferenceItem.bankFullName,
    };
    bankReferenceList.push(bankReference);
  });
  return bankReferenceList;
}
export function ToBankAccountList(_bankAccountList: any) {
  const bankAccountList = [];
  if (_bankAccountList !== null) {
    for (let i = 0; i < _bankAccountList.length; i++) {
      const bankAccountData = {
        id: _bankAccountList[i].id,
        merchantId: _bankAccountList[i].merchantId,
        name: _bankAccountList[i].name,
        bankName: _bankAccountList[i].bankName,
        bankNumber: _bankAccountList[i].bankNumber,
        description: _bankAccountList[i].description,
        bankAccountType: _bankAccountList[i].bankAccountType,
        bankRefTypeId: _bankAccountList[i].bankRefTypeId,
        isCashIn: _bankAccountList[i].isCashIn,
        isCashOut: _bankAccountList[i].isCashOut,
        startAmount: _bankAccountList[i].startAmount,
        haveCheque: _bankAccountList[i].haveCheque,
        bankType: _bankAccountList[i].bankType,
        code: _bankAccountList[i].code,
        urlBankLogo: _bankAccountList[i].urlBankLogo,
        fullName: _bankAccountList[i].fullName,
        status: "null",
        bankShortName: _bankAccountList[i].bankShortName,
      };
      bankAccountList.push(bankAccountData);
    }
  }
  return bankAccountList;
}

export function ConvertToChequeDetail(chequemodel: any) {
  const chequeDetail = {
    paymentInOutFlowTypeId: chequemodel.paymentInOutFlowType,
    paymentTransactionBankAccount: {
      cheque: {
        accountNumber: chequemodel.accountNumber,
        branchNumber: chequemodel.branchNumber,
        chequeBankId:
          chequemodel.paymentInOutFlowType == PaymentInOutFlowType.CashIn
            ? chequemodel.bankReferenceId
            : chequemodel.bankAccountId,
        chequeDate: chequemodel.createPaymentDate,
        chequeNumber: chequemodel.chequeNumber,
        id: chequemodel.id,
      },
      paymentAmount:
        chequemodel.paymentInOutFlowType == PaymentInOutFlowType.CashIn
          ? chequemodel.chequeTotal.FormatMoney()
          : (chequemodel.chequeTotal * -1).FormatMoney(),
    },
    transactionContact: {
      id: chequemodel.contactId,
    },
  };
  return chequeDetail;
}
